export default __webpack_public_path__ + "images/656174269c21c5954e3d9ccd3923bfc9.svg";